import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Nav,
  Navbar,
  NavItem,
  MenuItem,
  NavDropdown
} from 'react-bootstrap';

class MyNavBar extends Component {
  render() {
    return(
      <Navbar collapseOnSelect fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">Build the Mountain</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <NavItem><Link to="/dashboard">Dashboard</Link></NavItem>
            <NavItem><Link to="/exercises">Exercises</Link></NavItem>
          </Nav>
          <Nav pullRight>
            <NavDropdown title="Account" id="account-info">
              <MenuItem><Link to="/settings" /></MenuItem>
              <MenuItem onClick={() => this.props.logout()}><Link to="/">Sign out</Link></MenuItem>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

MyNavBar.propTypes = {
  logout: React.PropTypes.func.isRequired
}

export default MyNavBar;


// WEBPACK FOOTER //
// ./src/components/MyNavBar.jsx